/** Movement (px) before a press on the handle becomes a drag; below it, a tap is a tap. */
export const DRAG_START_PX = 4;

/** Fraction of the sheet's height a slow drag must cover to dismiss it. */
const DISMISS_FRACTION = 0.25;

/** Downward speed (px/ms) that dismisses regardless of distance -- a flick. */
const FLICK_VELOCITY = 0.5;

/** Furthest (px) the sheet lifts when dragged up past its resting place. */
const MAX_LIFT_PX = 16;

export function shouldDismissSheet(dy: number, velocity: number, sheetHeight: number): boolean {
  if (dy <= 0) return false;
  return dy > sheetHeight * DISMISS_FRACTION || velocity > FLICK_VELOCITY;
}

/** Where the sheet sits for a raw drag of `dy`: 1:1 downward, a short rubber band upward. */
export function dragOffset(dy: number): number {
  if (dy >= 0) return dy;
  return -Math.min(MAX_LIFT_PX, -dy / 4);
}
